import React, { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { FaFacebookSquare, FaInstagramSquare, FaLinkedin } from 'react-icons/fa';
import { FaSquareXTwitter } from 'react-icons/fa6';

export default function ContactForm() {
    const form = useRef();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        mobile: '',
        email: '',
        service: '',
        industry: '',
        message: '',
        recaptchaValue: null,
    });

    const [showRecaptcha, setShowRecaptcha] = useState(false);
    const [error, setError] = useState(null);
    
    
    const [formSend, setFormSend] = useState(false);



    useEffect(() => {
        if (showRecaptcha) {
            const script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js';
            script.async = true;
            document.head.appendChild(script);
        }
    }, [showRecaptcha]);

    const handleFormSubmit = async (e) => {


        setFormSend(true)
        
        e.preventDefault();
        if (!formData.recaptchaValue) {
            setError('Please complete the reCAPTCHA verification.');
            setFormSend(false)
            return;
        }

        try {
            setError(null);
            const response = await fetch("https://sbk-backend.vercel.app/submit-amcpp-form", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.error || "Something went wrong!");
            setFormSend(false)
            alert("Form sent successfully!");
            setFormData({
                firstName: '',
                lastName: '',
                mobile: '',
                email: '',
                message: '',
                service: '',
                industry:'',
                recaptchaValue: null,
            });

        } catch (error) {
            setError(error.message);
            setFormSend(false)
            console.error("Error submitting form:", error);
        }
    };

    const handleRecaptchaChange = (value) => {
        setFormData({ ...formData, recaptchaValue: value });
        setError(null);
    };

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (!showRecaptcha) setShowRecaptcha(true);
    };

    return (
        <div className="my-4 contact">
            <div className="row align-items-center contact-outer">
                {/* Google Map */}


                <div className="overlay-contact"></div>


                <div className="row align-items-center position-relative z-2">


                    <div className="col-md-5 contact-left px-5 py-5 ">
                        {/* Contact Information */}
                        <div className="d-flex flex-column mb-3 ">
                            <p className="fw-bold fs-4">Contact Information</p>
                            <p className='my-0'>Say something to start a live chat</p>
                        </div>

                        {/* Contact Details */}
                        <div className="d-flex flex-column mb-3 gap-3">
                            <p>
                                <a href="tel:+919967623999" className="text-dark text-decoration-none text-white">
                                    <i className="bi bi-telephone-fill me-2 text-white"></i>  +91 99676 23999
                                </a>
                            </p>
                            <p>
                                <a href="mailto: contact@sbataxconsultants.com" className="text-dark text-decoration-none text-white">
                                    <i className="bi bi-envelope-fill me-2 text-white"></i>  contact@sbataxconsultants.com


                                </a>
                            </p>
                            <div className="d-flex align-items-start">
                                <i className="bi bi-geo-alt-fill me-2 mt-1"></i>
                                <p className="mb-0">C-1011 10th Floor, Shubham Avenue, Pant Nagar Ghatkopar East, Mumbai - 400075.</p>
                            </div>

                        </div>

                        {/* Social Links */}
                        <div className="contact-icons col-md-6 mt-3 d-flex flex-row justify-content-around">
                            {/* <a href="#" className="fs-4 text-white"><FaFacebookSquare/></a> */}

                            <a target='_blank' href='https://twitter.com/sbataxconsult' className="fs-3 text-white"><FaSquareXTwitter  /></a>
                            <a target='_blank' href="https://www.instagram.com/sba_taxconsultants/" className="fs-3 text-white"><FaInstagramSquare /></a>
                            <a target='_blank' href="https://www.linkedin.com/company/sba-tax-consultants-llc/?viewAsMember=true" className="fs-3 text-white"><FaLinkedin  /> </a>
                            <a target='_blank' href="https://www.facebook.com/sbataxconsultants" className="fs-3 text-white"><FaFacebookSquare /> </a>
                        </div>
                    </div>



                    {/* Contact Form */}



                    <div className="col-md-6 contact-right">

                        <div className=" p-4  rounded contact-form">
                            <div className="overlay"></div>



                            <h2 className="text-center text-black mb-4 fw-bold">We'd Love to Hear From You</h2>
                            <form ref={form} onSubmit={handleFormSubmit} autoComplete="off">
                                <div className="row">
                                    <div className="col-md-6 mb-3 ">
                                        <label htmlFor="firstName" className='text-black form-label'>First Name  <span className='text-danger'> * </span></label>
                                        <input
                                            value={formData.firstName}
                                            onChange={handleInputChange}
                                            type="text"
                                            name="firstName"
                                            className="form-control   input-hollow"
                                            onKeyUp={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ''); }}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="lastName" className='text-black form-label'>Last Name  <span className='text-danger'> * </span></label>

                                        <input
                                            value={formData.lastName}
                                            onChange={handleInputChange}
                                            type="text"
                                            name="lastName"
                                            className="form-control   input-hollow"
                                            onKeyUp={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ''); }}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="mobile" className='text-black form-label mt-3'>Mobile  <span className='text-danger'> * </span></label>

                                        <input
                                            value={formData.mobile}
                                            onChange={handleInputChange}
                                            type="text"
                                            maxLength={13}
                                            minLength={10}
                                            name="mobile"
                                            className="form-control  input-hollow"
                                            onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, ''); }}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="email" className='text-black form-label mt-3'>Email  <span className='text-danger'> * </span></label>
                                        <input
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            type="email"
                                            name="email"
                                            className="form-control  input-hollow"
                                            onInput={(e) => { e.target.value = e.target.value.replace(/[^A-Za-z@.,0-9]/g, ''); }}
                                            required
                                        />
                                    </div>
                                </div>





                                <div className="row">

                                    <div className="mb-3 col-md-6">
                                        <label htmlFor="subject" className="text-black form-label my-3">Service  <span className='text-danger'> * </span></label>
                                        <select
                                            value={formData.service}
                                            onChange={handleInputChange}
                                            name="service"
                                            className="form-select"
                                            required
                                        >
                                            <option value="" disabled>Select a Service</option>
                                            <option value="Attestation and Other Engagements">Attestation and Other Engagements</option>
                                            <option value="Audit Reviews & Compilations ">Audit Reviews & Compilations </option>
                                            <option value="Employee Benefit Plan Audits">Employee Benefit Plan Audits</option>
                                            <option value="SOC Reporting">SOC Reporting</option>
                                        </select>
                                    </div>




                                    <div className="mb-3 col-md-6">
                                        <label htmlFor="subject" className="text-black form-label my-3">Industry <span className='text-danger'> * </span></label>
                                        <select
                                            value={formData.industry}
                                            onChange={handleInputChange}
                                            name="industry"
                                            className="form-select"
                                            required
                                        >
                                            <option value="" disabled>Select a Industry</option>
                                            <option value="Financial Services">Financial Services</option>
                                            <option value="Hospitality">Hospitality</option>
                                            <option value="Private Equity /Venture Capital">Private Equity /Venture Capital</option>
                                            <option value="Technology & Media and Entertainment">Technology & Media and Entertainment</option>
                                            <option value="Healthcare and Pharma">Healthcare and Pharma</option>
                                            <option value="Manufacturing and Distribution">Manufacturing and Distribution</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>




                                </div>






                                <div className="mb-3">
                                    <label htmlFor="message" className='text-black form-label mt-3'>Message <span className='text-danger'> * </span></label>

                                    <textarea
                                        value={formData.message}
                                        onChange={handleInputChange}
                                        className="form-control input-hollow"
                                        rows="1"
                                        name="message"
                                        onKeyUp={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z\s.,]/g, ''); }}
                                        required
                                    />
                                </div>

                                {showRecaptcha && (
                                    <div className="mb-3 text-center">
                                        <ReCAPTCHA
                                            sitekey="6Lcl0ygoAAAAAHKrsouKfVZMhLnkt6qZe2ecLy9x"
                                            onChange={handleRecaptchaChange}
                                            theme="light"
                                        />
                                        {error && <p className="text-danger mt-2">{error}</p>}
                                    </div>
                                )}

                                <div className="d-flex justify-content-start " >
                                    <button disabled={formSend} type="submit" className="btn btn-success px-4 py-2 fw-bold w-50 mt-3" >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>





                <div className="col-md-7 col-12">

                </div>

            </div>

        </div>
    );
}
